<template>
  <div class="page flex-col">
    <!-- 顶部导航由全局 SiteHeader 渲染，这里仅保留页面主体 -->
    <div class="group_2 flex-col">
      <div class="image-text_1 flex-row justify-between">
        <!-- 成果价值专用左侧菜单（4项） -->
        <div class="box_1 flex-col">
          <div class="section_1 flex-row justify-between" :class="{ 'active-menu': contentType === '德技双馨' }" @click="switchContent('德技双馨')" style="cursor: pointer;">
            <span class="text_10">德技双馨</span>
            <img class="thumbnail_3" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
          </div>
          <img class="image_3" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />
          <div class="section_2 flex-row justify-between" :class="{ 'active-menu': contentType === '教学示范' }" @click="switchContent('教学示范')" style="cursor: pointer;">
            <span class="text_11">教学示范</span>
            <img class="thumbnail_4" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
          </div>
          <img class="image_4" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />
          <div class="section_3 flex-row justify-between" :class="{ 'active-menu': contentType === '服务社会' }" @click="switchContent('服务社会')" style="cursor: pointer;">
            <span class="text_12">服务社会</span>
            <img class="thumbnail_5" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
          </div>
          <img class="image_5" :src="img('SketchPng9c3ce8bd283950762492e35258281653adc3f1ab8503324199e50d09865cffe9.png')" />
          <div class="section_4 flex-row justify-between" :class="{ 'active-menu': contentType === '引领示范' }" @click="switchContent('引领示范')" style="cursor: pointer;">
            <span class="text_13">引领示范</span>
            <img class="thumbnail_6" :src="img('SketchPng747db5e889a13bf4fb9dd0a589508efe343f959ef87a07a254a0ed6a1993f7e0.png')" />
          </div>
        </div>
        <LanhuDetailContent :content="currentContent" :pdfUrl="currentPdfUrl" :showImageWrapper="false" />
      </div>
      <!-- 页面内标题与面包屑已删除，与成果内容页保持一致（统一由 SiteHeader 控制全局标题/导航） -->
    </div>
  </div>
</template>

<script>
import LanhuDetailContent from '../../components/LanhuDetailContent.vue'
export default {
  components: { LanhuDetailContent },
  data() {
    return {
      contentTitle: '成果价值',
      contentType: '德技双馨',
      currentContent: '',
      currentPdfUrl: ''
    };
  },
  methods: {
    img(name) {
      // 复用详情页的静态资源
      return require(`../lanhu_wenzhangxiangqing/assets/img/${name}`);
    },
    buildValueHtml(type) {
      const paragraphs = {
        '德技双馨': [
          `<strong>人才培养质量全面提升，实现德技并修高质量发展</strong>`,
          `成果实施以来，人才培养质量显著提升。近三届毕业生最终就业率均稳定在98%以上（2023年达99.14%），专业对口率提升至40%以上，显著高于全国高职平均水平；跨境电商数智化岗位（如智能运营、数据诊断）占比达 65% ，新质技能适配度显著高于行业平均水平。麦可思数据显示，毕业生对教学的满意度、就业满意度、对母校的满意度等核心指标连续多年位列全校前三。`,
          `学生职业技能与创新精神显著增强，在全国职业院校技能大赛中获一等奖2项、二等奖1项，在世界职业院校技能大赛中获得银奖1项、铜奖2项，在"互联网+"大学生创新创业大赛中获国家级铜奖1项、省级金奖1项。毕业生可持续发展能力强，专升本录取比率高达87%，稳居全校第一，并涌现出以义乌五金行业协会副会长李荣军（安徽省"创业之星"）为代表的一批创业典型，形成"就业有竞争力、升学有基础、创业有能力"的良性发展格局。`
        ],
        '教学示范': [
          `<strong>教学资源与模式广泛辐射，形成专业建设示范标杆</strong>`,
          `成果所凝练的育人模式已成为可复制、可推广的改革范式，在校内外产生广泛影响。建成国家级精品在线课程2门、国家级教学资源库课程3门，主编"十四五"国家规划教材2本、省级规划教材7本，数字化资源惠及学生超2万人次。师资团队拥有省级教学名师2人、省级教学团队2个，获国家级教学能力大赛奖项4项。实训基地建设成果成为学校样板，接待逾10所省内外兄弟院校观摩学习。成果的先进理念与实操路径得到高度认可，牵头安徽省"1+X"跨境电商B2B证书试点，成功承办"全国跨境电商B2B数据运营'1+X'师资培训"（合肥站）及国培项目等，累计为全国9个省份、全省20余所高职院校的百余名教师提供了培训与交流平台，获省级优秀案例一等奖。成果核心内容亦被全国报关行指委年会等高水平会议采纳交流，人才培养新模式在省内乃至全国范围内起到重要示范作用，产教融合案例两次获安徽省校企合作典型案例一等奖。`
        ],
        '服务社会': [
          `<strong>社会服务能力持续增强，有效赋能行业与区域发展</strong>`,
          `成果有效赋能区域经济发展与行业升级，社会服务能力显著增强。专业教师团队深度参与行业服务，5名教师受聘为安徽省进出口商会业务与政策指导专家，面向地方政府与企业开展"RCEP 规则与跨境电商数智运营"等培训，覆盖全省 8 地市 120 家企业，累计培训人员近万人次。依托校政行企共建的产业学院与研究平台，培育新质技能人才，助力安徽"徽动全球"出海行动——为合肥荣事达小家电、芜湖三只松鼠等企业提供"智能选品 + 海外本土化运营"技术支持，助力企业提升数字化运营能力，推动安徽特色产品通过跨境电商出口额年均增长 18%，凸显 "安徽工商方案" 的区域价值。连续三年承办省级关务技能大赛，主办全国性行业会议，成为区域跨境电商教育与交流的核心平台。`
        ],
        '引领示范': [
          `<strong>示范引领效应不断凸显，成果获社会各界广泛认可</strong>`,
          `成果的扎实成效与创新价值获得了教育主管部门、行业组织及社会媒体的高度评价。学校担任全国跨境电商产教联盟副理事长单位等7个行业组织职务，参与国家教学标准研制。实训基地建设成果得到安徽省教育厅等领导现场视察时的充分肯定。相关改革实践被主流媒体关注报道，专业的建设成效与人才培养案例形成了良好的社会声誉。在多项权威评价中，学校的相关专业竞争力位居全国前列，成果为高职院校跨境电商领域深化产教融合、提升人才培养质量提供了成功的"安徽工商"方案，示范引领作用日益彰显。`
        ]
      };
      
      // 图片映射：按照四个菜单的顺序对应云存储图片
      const imageMap = {
        '德技双馨': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/jj/1.png',
        '教学示范': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/jj/2.png',
        '服务社会': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/jj/3.png',
        '引领示范': 'https://qqlvideo-1255458536.cos.ap-shanghai.myqcloud.com/school/jj/4.png'
      };
      
      const ps = paragraphs[type] || [];
      const textHtml = ps.map(p => `<p>${p}</p>`).join('');
      const imageHtml = imageMap[type] ? `<div style="text-align: center; margin-top: 30px;"><img src="${imageMap[type]}" style="max-width: 100%; height: auto;" alt="${type}" /></div>` : '';
      
      return textHtml + imageHtml;
    },
    async loadContent(type) {
      // 成果价值四个二级菜单：直接显示文本且不提供 PDF 预览
      this.currentPdfUrl = '';
      this.currentContent = this.buildValueHtml(type);
      this.contentTitle = type;
      this.contentType = type;
    },
    switchContent(type) {
      this.contentType = type;
      this.contentTitle = type;
      this.loadContent(type);
    }
  },
  mounted() {
    this.$nextTick(() => {
      // 根据路由参数初始化内容类型
      const initType = (this.$route && this.$route.query && this.$route.query.type) ? this.$route.query.type : this.contentType;
      this.switchContent(initType);
    });
  },
  watch: {
    // 监听头部下拉切换后的路由变化，更新当前展示内容
    $route(to) {
      const type = (to && to.query && to.query.type) ? to.query.type : '';
      if (type) {
        this.switchContent(type);
      }
    }
  }
};
</script>
<style scoped>
/* 下拉菜单容器保持与父级左对齐（仅用于左侧四项菜单的箭头与分隔线对齐） */
.dropdown-container .text_5 { display: inline-block; vertical-align: middle; }

/* 顶部蓝色短线与局部导航样式已移除，避免与 SiteHeader 重复 */

/* 成果价值页面菜单高亮效果 - 与LanhuSideMenu保持一致 */
/* 悬浮效果 */
.section_1:hover, .section_2:hover, .section_3:hover, .section_4:hover {
  background-color: #e8f4fd !important;
  border-left: 4px solid #215195 !important;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px 0 !important;
  margin: 20px 0 0 0 !important;
  width: 100% !important;
  height: auto !important;
  min-height: 41px !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
}

/* 选中状态高亮效果 */
.section_1.active-menu, .section_2.active-menu, .section_3.active-menu, .section_4.active-menu {
  background-color: #215195 !important;
  border-left: 4px solid #ff6b35 !important;
  color: white !important;
  padding: 8px 0 !important;
  margin: 20px 0 0 0 !important;
  width: 100% !important;
  height: auto !important;
  min-height: 41px !important;
  border-radius: 4px !important;
  box-sizing: border-box !important;
}

/* 选中状态下文字颜色和布局 */
.section_1.active-menu .text_10,
.section_2.active-menu .text_11,
.section_3.active-menu .text_12,
.section_4.active-menu .text_13 {
  color: white !important;
  font-weight: 700 !important;
  margin: 0 !important;
  line-height: 25px !important;
  padding-left: 30px !important;
  display: flex !important;
  align-items: center !important;
  height: 25px !important;
}

/* 悬浮状态下文字颜色和布局 */
.section_1:hover .text_10,
.section_2:hover .text_11,
.section_3:hover .text_12,
.section_4:hover .text_13 {
  color: black !important;
  font-weight: 600 !important;
  margin: 0 !important;
  line-height: 25px !important;
  padding-left: 30px !important;
  display: flex !important;
  align-items: center !important;
  height: 25px !important;
}

/* 确保菜单项使用flexbox布局 */
.section_1, .section_2, .section_3, .section_4 {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  box-sizing: border-box !important;
}
</style>

<!-- 复用原详情页的样式定义（非 scoped，确保类名在子组件内生效） -->
<style lang="css" src="../lanhu_wenzhangxiangqing/assets/index.css"></style>